import React from "react";

/**
 * Official Autordo logo (PNG). Served from /logo.png in /public.
 * `size` controls the rendered width in pixels (height auto from intrinsic ratio).
 */
export default function Logo({ size = 64, className = "" }) {
  return (
    <img
      src="/logo.png"
      alt="Autordo"
      width={size}
      height={size}
      className={`block object-contain ${className}`}
      style={{ width: size, height: size }}
      data-testid="autordo-logo"
    />
  );
}
